// meditations.ts — the standalone guided meditations (hosted on Bunny Stream),
// surfaced in "Your stuff" and played in the normal video viewer. These are not
// part of the ordered programme; they're a library to return to any time.

import type { Step } from '@/types';

const PULL_ZONE = 'vz-a88484ef-70e.b-cdn.net'; // Bunny Stream pull-zone host (mp4 plays in both webviews)

export interface Meditation {
  id: string;
  title: string;
  /** Running time in minutes, when known. */
  minutes: number | null;
  video_url: string;
  poster_url: string;
}

// guid + title + length, in a gentle order (the self-compassion series, then the
// grounding and the in-programme meditations).
const RAW: { guid: string; title: string; minutes: number | null }[] = [
  { guid: '8f3c8953-a661-4f8b-89b0-a6bbaf0cd8e0', title: 'Calming Beach Escape', minutes: 15 },
  { guid: 'a1f07142-3d2f-4bdf-bb8a-1be4cc84710a', title: 'Calming Space — Forest', minutes: 15 },
  { guid: 'a45c43f1-b6c5-4770-bd00-8e1318291ffa', title: 'Free and Loving Self', minutes: 15 },
  { guid: 'cc5ad67c-9d2d-4d8e-987e-7a394066291f', title: 'Activating an inner soothing voice', minutes: 12 },
  { guid: 'c6d4751a-c052-4d62-beb1-2bb722b860aa', title: 'Complex Not Broken', minutes: 14 },
  { guid: 'cf9e8b7f-0099-4c38-af7f-7753c0f01658', title: 'Loving Kindness', minutes: 12 },
  { guid: '0110e42a-1181-41f9-8f81-c7adf4d3bcf2', title: 'Mindful Body Awareness', minutes: 14 },
  { guid: '598d499a-b599-47a9-bab2-c0218a9ba32e', title: 'Soothing our suffering', minutes: 11 },
  { guid: 'a2632a53-6224-4aa1-b997-e1c58ff104bd', title: 'Grounding Exercise', minutes: 15 },
  { guid: '700fa33d-c12a-403f-8398-b40d7e4a8bbf', title: 'Listening for our own needs', minutes: null },
  { guid: '98ed124f-4538-4f87-bedb-fb2ef3d74d6d', title: 'Soothing breathing', minutes: null },
  { guid: '7fbb705a-6dbf-426b-abd7-d61a8de26aa3', title: 'Soothing distress through self-compassion', minutes: null },
];

export const MEDITATIONS: Meditation[] = RAW.map((m) => ({
  id: `meditation-${m.guid}`,
  title: m.title,
  minutes: m.minutes,
  video_url: `https://${PULL_ZONE}/${m.guid}/play_720p.mp4`,
  poster_url: `https://${PULL_ZONE}/${m.guid}/thumbnail.jpg`,
}));

/** Adapt a meditation into a one-off video Step for the existing viewer. */
export function meditationToStep(m: Meditation): Step {
  return {
    id: m.id,
    module_id: 'meditations',
    title: { pre: m.title, em: '' },
    order: 0,
    type: 'video',
    completion_required: false,
    video_url: m.video_url,
    poster_url: m.poster_url,
    duration: m.minutes ? m.minutes * 60 : undefined,
  };
}
